// FIXME: Move all the vue boilerplate into one file

import vueable from "./vueable"
import Event from '../components/Event'

vueable.setupVue({el: "#app", components: { Event}})